import { createAsyncThunk } from '@reduxjs/toolkit';

import { ROUTE, Params, Result } from 'api/docusign/get-envelope/params';
import { ApiResponse } from 'src/types/api-response';

import { api } from 'utils/api';

export const getEnvelopeUrl = createAsyncThunk<ApiResponse<Result>, Params, { rejectValue: string }>(
  'user/getEnvelopeUrl',
  async (data, { rejectWithValue }) => {
    let responseErrorCode: unknown;
    try {
      const response = await api.sendRequest<Result>({
        url: ROUTE,
        method: 'GET',
        data,
      });

      if (response.success) {
        return response;
      }

      const message = typeof response.error.message === 'string' ? response.error.message : 'Request failed';
      responseErrorCode = response.error.code;
      throw new Error(message);
    } catch (e) {
      console.error('[DocuSign] Recipient view request failed', {
        type: data.type,
        code: responseErrorCode,
        message: (e as Error).message,
      });
      return rejectWithValue((e as Error).message);
    }
  }
);
